import styled, { keyframes, css } from 'styled-components';

/* ── paleta do design system ── */
const TEAL = 'var(--teal)';
const TEAL_LIGHT = 'var(--teal-light)';
const TEAL_SOFT = 'var(--teal-soft)';
const GRAY_BG = 'var(--bg)';
const GRAY_LINE = 'var(--line)';
const GRAY_TEXT = 'var(--text-muted)';
const GREEN = 'var(--green)';
const GREEN_SOFT = 'var(--green-soft)';
const RED = 'var(--red)';
const RED_SOFT = 'var(--red-soft)';

const CORAL = 'var(--coral)';
const TEAL_GLOW = 'var(--teal-glow)';

const bp = { desktop: '1024px', tablet: '768px', mobile: '540px', small: '420px' };

const shimmer = keyframes`0% { background-position: -400px 0; } 100% { background-position: 400px 0; }`;
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const expand = keyframes`
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  overflow-x: hidden;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--bg-glow) 0%, transparent 70%),
    ${GRAY_BG};
  @media (max-width: ${bp.tablet}) { padding: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 8px; }
`;

export const ContainerEmp = styled.div`
  width: 100%;
  max-width: 960px;
  box-sizing: border-box;
`;

/* ── busca + filtro ── */
export const Search = styled.div`
  width: 100%;
  max-width: 960px;
  box-sizing: border-box;
  display: flex;
  gap: 14px;
  margin-bottom: 12px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 16px 18px;
  animation: ${fadeUp} 0.35s ease;
  @media (max-width: ${bp.tablet}) { flex-direction: column; gap: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 14px; }
`;

export const FormSearch = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  label { color: ${GRAY_TEXT}; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 7px; }
  @media (max-width: ${bp.tablet}) { width: 100%; }
`;

export const FormFilter = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  label { color: ${GRAY_TEXT}; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 7px; }
  @media (max-width: ${bp.tablet}) { width: 100%; }
`;

export const Area = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  /* ícone de lupa */
  &::before {
    content: '🔍';
    position: absolute;
    left: 12px;
    font-size: 14px;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const InputEmp = styled.input`
  height: 44px;
  width: 100%;
  padding: 0 12px 0 36px;
  border: 1px solid ${GRAY_LINE};
  border-radius: 11px;
  font-size: 15px;
  font-family: inherit;
  background: ${GRAY_BG};
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
  box-sizing: border-box;
  &:focus {
    outline: none;
    background: var(--surface);
    border-color: ${TEAL_LIGHT};
    box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 0 12px;
  height: 44px;
  border: 1px solid ${GRAY_LINE};
  border-radius: 11px;
  font-size: 15px;
  font-family: inherit;
  color: var(--text-2);
  background: ${GRAY_BG};
  cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease;
  &:focus {
    outline: none;
    border-color: ${TEAL_LIGHT};
    box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12);
  }
`;

/* ── botão novo funcionário ── */
export const DivNewEmp = styled.div`
  display: flex;
  width: 100%;
  max-width: 960px;
  box-sizing: border-box;
  justify-content: flex-end;
  padding: 2px 0 6px;
  @media (max-width: ${bp.mobile}) { justify-content: stretch; }
`;

export const Btt02 = styled.button`
  padding: 11px 22px;
  background: ${TEAL};
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  box-shadow: 0 2px 8px ${TEAL_GLOW};
  transition: filter .15s ease, transform .12s ease;
  &::before { content: '＋'; font-size: 16px; }
  &:hover { filter: brightness(1.06); transform: translateY(-1px); }
  &:active { transform: translateY(0); }
  @media (max-width: ${bp.mobile}) { width: 100%; justify-content: center; }
`;

/* ── lista ── */
export const List = styled.div`
  width: 100%;
  max-width: 960px;
  box-sizing: border-box;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > p {
    font-size: 13px;
    font-weight: 700;
    color: ${GRAY_TEXT};
    margin: 2px 2px 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    em {
      font-style: normal;
      color: ${CORAL};
      font-weight: 700;
    }
  }
`;

export const Emp = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding: 13px 16px;
  gap: 12px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-left: 3px solid ${TEAL};
  border-radius: 11px;
  cursor: pointer;
  transition: background .15s ease, transform .12s ease, box-shadow .15s ease, border-color .15s ease;
  animation: ${fadeUp} 0.3s ease backwards;
  &:hover {
    background: ${TEAL_SOFT};
    transform: translateX(3px);
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
    border-left-color: ${CORAL};
  }
  @media (max-width: ${bp.mobile}) { padding: 12px 14px; }
`;

/* avatar de iniciais à esquerda do nome */
export const Avatar = styled.span`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_LIGHT} 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;

export const EmpMain = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  flex: 1;
`;

export const Span = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: ${bp.mobile}) { font-size: 14px; }
`;

/* badge de status */
export const StatusBadge = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-radius: 999px;
  padding: 4px 11px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  &::before { content: '●'; font-size: 8px; }
  ${({ $active }) => $active
    ? css`background: ${GREEN_SOFT}; color: ${GREEN};`
    : css`background: ${RED_SOFT}; color: ${RED};`}
`;

export const LoadMoreText = styled.p`
  text-align: center;
  padding: 10px;
  color: ${GRAY_TEXT};
  font-size: 13px;
  font-weight: 600;
`;

export const EmptyState = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 16px;
  color: ${GRAY_TEXT};
  font-size: 14px;
  border: 1px dashed ${GRAY_LINE};
  border-radius: 12px;
  background: var(--surface);
  .em { display: block; font-size: 32px; margin-bottom: 8px; }
`;

/* ── skeleton ── */
const skeletonBase = css`
  background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.3s linear infinite;
  border-radius: 8px;
`;
export const SkeletonRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px 16px;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-left: 3px solid ${GRAY_LINE};
  border-radius: 11px;
  //.circle { ${skeletonBase} width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0; }
  //.bar { ${skeletonBase} height: 14px; flex: 1; }
  //.pill { ${skeletonBase} height: 20px; width: 60px; border-radius: 999px; flex-shrink: 0; }
`;

/* ── modal de aviso ── */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 30, 38, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647;
  padding: 16px;
  animation: ${fadeIn} 0.15s ease;
  @media (max-width: ${bp.mobile}) { padding: 0; align-items: flex-end; }
`;

export const Modal = styled.div`
  background: var(--surface);
  border-radius: 16px;
  padding: 26px 24px;
  width: 100%;
  max-width: 460px;
  box-sizing: border-box;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
  text-align: center;
  animation: ${expand} 0.2s ease;
  h3 {
    margin: 0 0 12px;
    font-size: 18px;
    color: ${RED};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  p { margin: 0 0 20px; color: ${GRAY_TEXT}; font-size: 14px; line-height: 1.55; text-align: left; }
  @media (max-width: ${bp.mobile}) { border-radius: 18px 18px 0 0; padding: 24px 18px; max-width: 100%; }
`;

/* lista dos períodos que faltam registrar */
export const MissingList = styled.ul`
  list-style: none;
  margin: 12px 0;
  padding: 10px 12px;
  border: 1px solid ${RED};
  border-left: 4px solid ${RED};
  border-radius: 8px;
  background: ${RED_SOFT};

  li {
    color: ${RED};
    font-weight: 700;
    font-size: 13.5px;
    padding: 3px 0;
    display: flex;
    align-items: center;
    gap: 8px;
    &::before { content: '●'; font-size: 8px; }
  }
`;

export const ModalButton = styled.button`
  padding: 11px 28px;
  border: none;
  border-radius: 10px;
  background: ${TEAL};
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  box-shadow: 0 2px 8px ${TEAL_GLOW};
  transition: filter .15s ease, transform .12s ease;
  &:hover { filter: brightness(1.06); transform: translateY(-1px); }
`;